import { OrderStatus } from "../../../../core/schema/OrderStatus.js";

export const orderStatusTextColorMap: Record<OrderStatus, string> = {
	[OrderStatus.Accepted]: "text-blue",
	[OrderStatus.Manufactured]: "text-blue",
	[OrderStatus.ReadyForPickup]: "text-orange",
	[OrderStatus.Delivered]: "text-tertiary",
	[OrderStatus.Cancelled]: "text-primary",
};
